export const HOME = "/IT-Girls";
export const ABOUT = "/IT-Girls/about";
export const HISTORY = "/IT-Girls/history";
export const ELIGIBILITY = "/IT-Girls/eligibility";
